import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import BannerHomeEditor from 'components/editor/movies/home/banner';
import PreviewHomeEditor from 'components/editor/movies/home/preview';
import StandardHomeEditor from 'components/editor/movies/home/standard';

export default (props) => {
	if (isFocusStudio()) {
		return <BannerHomeEditor {...props} />;
	}

	const heroType = props.data?.content?.pages?.home?.heroMode;
	if (heroType === 'preview') {
		return <PreviewHomeEditor {...props} />;
	}

	return <StandardHomeEditor {...props} />;
};